/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AutoCompleteFilter,
    AutoCompleteFilterFromJSON,
    AutoCompleteFilterToJSON,
    AutoCompleteItem,
    AutoCompleteItemFromJSON,
    AutoCompleteItemToJSON,
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelToJSON,
    ProblemDetails,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models';

export interface ApiAutoCompleteAllPostRequest {
    autoCompleteItem?: AutoCompleteItem;
}

export interface ApiAutoCompletePostRequest {
    autoCompleteFilter?: AutoCompleteFilter;
}

/**
 * no description
 */
export class AutoCompleteApi extends runtime.BaseAPI {

    /**
     */
    async apiAutoCompleteAllPostRaw(requestParameters: ApiAutoCompleteAllPostRequest): Promise<runtime.ApiResponse<AutoCompleteItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/AutoComplete/all`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AutoCompleteItemToJSON(requestParameters.autoCompleteItem),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AutoCompleteItemFromJSON(jsonValue));
    }

    /**
     */
    async apiAutoCompleteAllPost(requestParameters: ApiAutoCompleteAllPostRequest): Promise<AutoCompleteItem> {
        const response = await this.apiAutoCompleteAllPostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiAutoCompletePostRaw(requestParameters: ApiAutoCompletePostRequest): Promise<runtime.ApiResponse<Array<GuidIdCodeAndLabel>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/AutoComplete`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AutoCompleteFilterToJSON(requestParameters.autoCompleteFilter),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GuidIdCodeAndLabelFromJSON));
    }

    /**
     */
    async apiAutoCompletePost(requestParameters: ApiAutoCompletePostRequest): Promise<Array<GuidIdCodeAndLabel>> {
        const response = await this.apiAutoCompletePostRaw(requestParameters);
        return await response.value();
    }

}
